export default {
  beforeRouteLeave(to, from, next) {
    // 如果保存操作后的跳转 直接跳转
    if (this.isSaved) {
      next();
    } else {
      this.$confirm("此时离开将丢失已编辑的内容，是否确认离开？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
          this.$store.commit("setActiveIndex", this.activeIndex);
        });
    }
  },
};
